import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const SN_PUR_PTX_REP_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const [gridFocus1, setGridFocus1] = useState(false);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({ grid1: rtn.grid.grid1 });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  useEffect(() => {
    getGridCurrent("grid1").selectAndFocusRow(0);
    setGridFocus1(false);
  }, [gridFocus1]);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_pur_ptx_rep_002_01",
        params: searchRef.current.getFormdata(),
      };
      setDataSources({ grid1: [] });
      const data: any = await fnGetDataSet(param);
      setDataSources({ grid1: data[0] });
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus1(true);
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  //#region UI

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}

        />
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            title: "매입확정정보",
            isEditable: false,
          }}
        />
      </div>
    </div>
  );
});

export default SN_PUR_PTX_REP_002;
